<template>
    <left-stripe-layout
        class="d-flex flex-column justify-center" 
        :color="announcement.color"
    >
        <Header 
            class="header"
            :large="false" 
            :two-line="false"
            :color="announcement.color"
            :icon="announcement.iconName"
            :text="announcement.title"
        ></Header>
        <div class="announcement-content" :style="{'--base-color': announcement.color}">
            <p class="announcement-text" v-if="meals.length === 0 && facility">{{message}}..</p>
            <p class="announcement-text" v-else-if="!facility">Nebyla zvolena výdejna stravy...</p>
            <table v-else class="table">
                <col :width="isPreview ? '50%' : '60%'" />          
                <col width="14%" />
                <col width="14%" />
                <col :width="isPreview ? '22%' : '12%'" />
                <tr class="table-head">
                    <th v-for="(column, idx) in columns" :key="`meal-head-${column}`" v-bind:class="{'center-cell': idx > 0 && idx < 3, 'pl-6': idx == 3}">
                        {{column}}
                    </th>
                </tr>
                <tr v-for="n in rowCount" :key="`meal-${n}`">
                    <td class="meal-name-cell">
                        <component 
                            v-if="getMeal(n-1).type"
                            class="meal-icon"
                            :is="getIconComponent(getMeal(n-1).type)">
                        </component>
                        <Marquee class="meal-name" :items="[getMeal(n-1).mealName]" :fixedAnimationDuration="refreshPeriod * 1000" padding="0px" />
                    </td>
                    <td class="center-cell">
                        <div v-if="getMeal(n-1).priceStudent" class="px-1 py-0 mx-3 meal-price">{{`${getMeal(n-1).priceStudent} Kč`}}</div>
                    </td>
                    <td class="center-cell">
                        <div v-if="getMeal(n-1).priceEmployee" :color="announcement.color" class="px-1 py-0 mx-3 meal-price-color">{{`${getMeal(n-1).priceEmployee} Kč`}}</div>
                    </td>
                    <td class="pl-6">
                        <Marquee padding="0px" :items="[getMeal(n-1).allergens]" :fixedAnimationDuration="refreshPeriod * 1000"/>
                    </td>
                </tr>
                <tr v-if="this.notVisibleMealsCount > 0">
                    <td colspan="5" class="and-more">
                        {{this.announcement.language === this.cz ? `a ${this.notVisibleMealsCount} další${this.notVisibleMealsCount > 4 ? 'ch' : ''}` : `and ${this.notVisibleMealsCount} more`}}...
                    </td>
                </tr>
            </table>
        </div>   
    </left-stripe-layout>
</template>

<script>
import {config} from "../../../config";
import Header from '../../../components/Header';
import LeftStripeLayout from './Layouts/LeftStripeLayout.vue';
import Marquee from '../../../components/Marquee';
import SoupIcon from '../../../assets/food_type_soup.svg';
import SmallFoodIcon from '../../../assets/food_type_short_order.svg';
import DefaultFoodIcon from '../../../assets/food_type_default.svg'

export default {
    name: "FoodService",

    props: {
        announcement: Object,
        isLandscape: Boolean,
        isParallel: Boolean,
        refreshPeriod: Number,
        isPreview: Boolean
    },

    data: () => ({
        cz: config.cz,
        maxItems: 12
    }),

    computed: {
        meals() {
            return (this.isPreview 
                ? this.previewMeals(this.announcement.serviceConfiguration ? this.facility : undefined)
                : JSON.parse(this.announcement.text).meals);
        },

        notVisibleMealsCount() {
            return this.meals.length - this.maxItems;
        },

        rowCount() {
            return Math.max(Math.min(this.meals.length, this.maxItems), 8);
        },

        message() {
            return JSON.parse(this.announcement.text).message;
        },

        facility() {
            return this.isPreview ? this.announcement.serviceConfiguration.facility : JSON.parse(this.announcement.serviceConfiguration).facility;
        },

        columns() {
            return this.announcement.language === this.cz 
                ? [ 'Jídla', 'Student', 'Zaměst.', 'Alergeny' ] 
                : [ 'Meals', 'Student', 'Employee', 'Allergens' ];
        }
    },

    components: {
        Header,
        LeftStripeLayout,
        Marquee,
        SoupIcon,
        SmallFoodIcon,
        DefaultFoodIcon
    },

    methods: {
        previewMeals(facility) {
            const isCz = this.announcement.language === this.cz;
            return facility ? [
                { mealName: 'Slepičí vývar', type: 'Soup', allergens: '1, 7, 9', priceStudent: isCz ? '14,3' : 14.3, priceEmployee: isCz ? '14,3' : 14.3},
                { mealName: 'Polévka kapustová', type: 'Soup', allergens: '1, 6, 7', priceStudent: isCz ? '14,3' : 14.3, priceEmployee: isCz ? '14,3' : 14.3},
                { mealName: 'Hovězí soté s bazalkou 100g, jasmínová rýže, salát', type: 'Main dish', allergens: '1, 9, 14', priceStudent: isCz ? '66,5' : 66.5, priceEmployee: isCz ? '43' : 43},
                { mealName: 'Hrachová kaše, klobása', type: 'Main dish', allergens: '6, 9', priceStudent: 69, priceEmployee: isCz ? '79,5' : 79.5},
                { mealName: 'Kuřecí prsa se chilli omáčkou 120g, hranolky, tatarka', type: 'Main dish', allergens: '9', priceStudent: 72, priceEmployee: isCz ? '49,5' : 49.5},
                { mealName: 'Bramborový guláš s uzeninou, krájený chléb', type: 'Main dish', allergens: '1, 9, 14', priceStudent: isCz ? '65,2' : 65.2, priceEmployee: isCz ? '42,8' : 42.8},
                { mealName: 'Smažený sýr, brambory, tatarka', type: 'Fast food', allergens: '1, 3, 7, 10', priceStudent: 72, priceEmployee: isCz ? '49,8' : 49.8}
            ] : []
        },

        getIconComponent(mealType) {
            switch (mealType) {
                case 'Soup':
                    return "SoupIcon";
                case 'Fast food':
                    return "SmallFoodIcon";
                default:
                    return "DefaultFoodIcon"
            }
        },

        getMeal(index) {
            return index < this.meals.length ? this.meals[index] : { mealName: '', type: '', allergens: '', priceStudent: undefined, priceEmployee: undefined};
        },
    }
}
</script>

<style scoped>
    .center-cell {
        text-align: center;
    }

    .announcement {
        background: black;
        color: white;
        overflow: hidden;
        font-family: 'Roadgeek';
    }

    .announcement-text {
        font-size: 1.7vw;
    }

    .announcement-content {
        width: 100%;
        height: 100%;
        display: flex;
        flex-flow: row;
        justify-content: space-between;
    }

    .meal-icon {
        width: 3.25vw;
        padding-bottom: 5px;
        fill: var(--base-color);
    }

    .meal-name-cell {
        display: flex;
        align-items: center;
        height: 100%;
    }

    .meal-name {
        margin-left: 1vw;
        margin-right: 1vw;
    }

    .and-more {
        color: var(--base-color);
        padding-left: 4vw;
    }

    .meal-price {
        background: white;
        color: black;
        border-radius: 6vh;
        min-width: 11vw;
    }

    .meal-price-color {
        color: black;
        background-color: var(--base-color);
        border-radius: 6vh;
        min-width: 11vw;
    }

    .table {
        width: 100%;
        height: 97%;
        font-size: 1.9vw;
        text-align: left;
        table-layout: fixed;
    }

    .table-head {
        color: var(--base-color);
    }
</style>
